/** Class string for inline blue links (Figma Label/Medium in brand blue): `<Link className={textLinkClass}>`. */
export const textLinkClass =
  'text-label-medium text-brand-primary hover:underline focus-visible:outline-none focus-visible:shadow-(--mbm-shadow-focus-ring) rounded-(--mbm-radius-xs)';
